export default __webpack_public_path__ + "654d7af24b36de8c84b0e27f536803c2.png";